import styled from 'styled-components';

export const SidebarContainer = styled.div`
  position: relative;
  max-width: none;
  width: auto;
  margin: 30px auto 0;
  min-height: calc(100vh - ${({ theme }) => theme.sizes.navbarMobile});

  @media ${({ theme }) => theme.device.tablet} {
    margin: 60px 32px 0;
    min-height: calc(100vh - ${({ theme }) => theme.sizes.navbar} - 60px);
    &.no-margin-inline {
      margin-inline: 24px;
    }
  }

  @media ${({ theme }) => theme.device.laptopL} {
    margin: 80px 80px 0 75px;
    min-height: calc(100vh - ${({ theme }) => theme.sizes.navbar} - 80px);
    &.no-margin-inline {
      margin-inline: auto;
    }
  }

  @media ${({ theme }) => theme.device.desktopL} {
    margin: 80px 80px 0 140px;
    min-height: calc(100vh - ${({ theme }) => theme.sizes.navbar} - 80px);
    &.no-margin-inline {
      margin-inline: auto;
    }
  }
`;

export default SidebarContainer;
